import { createStore } from 'vuex'

export default createStore({
  state: {
    // Define your state here
    count: 0,
    user: JSON.parse(localStorage.getItem('user')) || null,
    notification: null,
    partnerDetails: null,
    dashboardData: {
      prospects: {
        2022: 150,
        2023: 280,
        2024: 420
      },
      customers: {
        2022: 80,
        2023: 180,
        2024: 320
      }
    },
    teams: [
      {
        id: 1,
        name: 'Alpha Team',
        email: 'alpha@partner.com',
        registeredOn: '2023-01-15',
        status: 'Live',
        type: 'Live'
      },
      {
        id: 2,
        name: 'Beta Team',
        email: 'beta@partner.com',
        registeredOn: '2023-03-20',
        status: 'Prospect',
        type: 'Prospect'
      },
      {
        id: 3,
        name: 'Gamma Team',
        email: 'gamma@partner.com',
        registeredOn: '2023-06-10',
        status: 'Live',
        type: 'Live'
      },
      {
        id: 4,
        name: 'Delta Team',
        email: 'delta@partner.com',
        registeredOn: '2023-09-05',
        status: 'Prospect',
        type: 'Prospect'
      }
    ]
  },
  getters: {
    // Define your getters here
    getCount: (state) => state.count,
    getUser: (state) => state.user,
    isLoggedIn: (state) => !!state.user,
    getNotification: (state) => state.notification,
    getDashboardData: (state) => state.dashboardData,
    getTeams: (state) => state.teams,
    getTeamsByType: (state) => (type) => {
      return state.teams.filter(team => team.type === type)
    },
    getPartnerDetails: (state) => state.partnerDetails
  },
  mutations: {
    // Define your mutations here
    INCREMENT_COUNT(state) {
      state.count++
    },
    DECREMENT_COUNT(state) {
      state.count--
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    CLEAR_USER(state) {
      state.user = null
      localStorage.removeItem('user')
    },
    SET_NOTIFICATION(state, notification) {
      state.notification = notification
    },
    CLEAR_NOTIFICATION(state) {
      state.notification = null
    },
    UPDATE_TEAM_STATUS(state, { teamId, status }) {
      const team = state.teams.find(t => t.id === teamId)
      if (team) {
        team.status = status
        team.type = status
      }
    },
    ADD_TEAM(state, team) {
      state.teams.push(team)
    },
    SET_PARTNER_DETAILS(state, details) {
      state.partnerDetails = details
    }
  },
  actions: {
    // Define your actions here
    incrementCount({ commit }) {
      commit('INCREMENT_COUNT')
    },
    decrementCount({ commit }) {
      commit('DECREMENT_COUNT')
    },
    login({ commit }, user) {
      // Simulate async login
      return new Promise((resolve) => {
        setTimeout(() => {
          commit('SET_USER', user)
          resolve(user)
        }, 1000)
      })
    },
    logout({ commit }) {
      commit('CLEAR_USER')
    },
    setNotification({ commit }, notification) {
      commit('SET_NOTIFICATION', notification)
      // Auto clear notification after 3 seconds
      setTimeout(() => {
        commit('CLEAR_NOTIFICATION')
      }, 3000)
    },
    updateTeamStatus({ commit }, payload) {
      commit('UPDATE_TEAM_STATUS', payload)
    },
    addTeam({ commit }, team) {
      commit('ADD_TEAM', team)
    },
    
    setUserEmail({ commit }, email) {
      commit('SET_USER', { email })
    },
    
    setPartnerDetails({ commit }, details) {
      commit('SET_PARTNER_DETAILS', details)
    },
    
    initializeStore({ state }) {
      // Initialize store with persisted data
      const user = localStorage.getItem('user')
      if (user) {
        try {
          state.user = JSON.parse(user)
        } catch (error) {
          console.error('Error parsing user data from localStorage:', error)
          localStorage.removeItem('user')
        }
      }
    }
  },
  modules: {
    // Define your modules here if needed
  }
}) 